module.exports = __webpack_public_path__ + "static/media/رحلات إلى انترلاكن.6518d9b8.jpg";